
module Meevo {

    export class MeevoTranslateInterpolation {
        private meevoFieldLabels: Object = {};
        private $locale: any;
        constructor(protected $http: angular.IHttpService, protected $rootScope: angular.IRootScopeService, protected appSettings: Meevo.Components.Common.IAppSettings, protected $interpolate: any, private $q: angular.IQService) {

            this.appSettings.APP_FIELDLABELS = this.getFieldLabels().then((response)=> {
                return response.data;
            }, (err: any) => {
                    console.log(err);
                    this.$q.reject(null);
            });   
            
        }

        getFieldLabels(): angular.IPromise<any> {
            var deffered = this.$q.defer();            
            this.$http.get('api/Settings/FieldLabels')
                .then((response: any) => {
                    response.data.settings.forEach((setting: any) => {
                        let key: string = setting.displayName;
                        let value: string = setting.effectiveValue;
                        this.meevoFieldLabels[key] = value;
                        this.meevoFieldLabels[key.charAt(0).toLowerCase() + key.substr(1)] = value.toLowerCase();
                    });
                    this.appSettings.APP_FIELDLABELS = this.meevoFieldLabels;
                    deffered.resolve(this.meevoFieldLabels);
                    //  this.$rootScope.$broadcast(Meevo.Components.Common.Messages.MEEVO_FIELD_LABELS_SET, this.meevoFieldLabels);
                }, (error: any) => {
                        console.log("getfields : " + error);
                        deffered.reject(null);
                });
            return deffered.promise;
        }

        setLocale(locale): void {
            this.$locale = locale;
        }

        getInterpolationIdentifier(): string {
            return 'meevoTranslateInterpolation';
        }

        interpolate(string, interpolateParams, context, sanitizeStrategy, translationId): any {
            let interParams = interpolateParams || {}
            let interpolate: string = this.$interpolate(string)(_.defaults(interParams, this.meevoFieldLabels), sanitizeStrategy)

            return interpolate;
        }

        static factory(): angular.IDirectiveFactory {
            let svc = ($http: angular.IHttpService, $rootScope: angular.IRootScopeService, appSettings: Meevo.Components.Common.IAppSettings, $interpolate: any, $q: angular.IQService) => {
                return new MeevoTranslateInterpolation($http, $rootScope, appSettings, $interpolate, $q);
            }

            svc.$inject = ["$http", "$rootScope", "meevo.AppSettings", "$interpolate","$q"];
            return svc;
        }
    }

    angular.module("meevo")
        .factory("meevoTranslateInterpolation", MeevoTranslateInterpolation.factory());

}